import { Card, Flex } from "antd";
import styled, { css } from "styled-components";

import { PrimaryText } from "@/shared/ui";

export const StyledInfoTitle = styled(PrimaryText).attrs({
    fontSize: 16,
    fontWeight: "500",
})``;

export const StyledProfileCard = styled(Card)`
    border-radius: 10px;
    border: none;
    width: 100%;
`;

export const StyledInfoBlock = styled(Flex)<{
    $borderBottom?: boolean;
}>`
    flex-direction: column;
    gap: 8px;

    ${({ $borderBottom, theme }) =>
        $borderBottom &&
        css`
            border-bottom: 1px solid ${theme.secondaryBorderColor};
            padding-bottom: 16px;
        `}
`;
